import { DialogTitle } from "@mui/material";

const BasicDialogTitle = ({ header }) => {
  return <DialogTitle {...{ sx: { paddingBottom: 2 } }}>{header}</DialogTitle>;
};

export default BasicDialogTitle;
